













































































































import { localISO } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import ApdSurveilansService from "@/services/ApdSurveilansService";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";

interface DetailEntry {
  apd_jenis_id: number;
  hasil: "patuh" | "tidak_patuh" | "na";
  catatan?: string;
}

@Component({
  components: { PersonAutoComplete }
})
export default class ApdSurveilansObservasiLogger extends Vue {
  @Prop({ required: true }) sessionId!: number;

  sessionNomor = "";
  jenisList: any[] = [];

  entry: any = {
    nama_petugas: "",
    profesi_jabatan: "perawat",
    tindakan_nama: "",
    catatan: "",
    details: [] as DetailEntry[]
  };

  buffer: any[] = [];
  saving = false;
  submitting = false;
  savedCount = 0;
  submitDialog = false;
  submitForm: any = { password: "", override_min_observasi_reason: "" };

  profesiOptions = [
    { text: "Dokter", value: "dokter" },
    { text: "Perawat", value: "perawat" },
    { text: "Bidan", value: "bidan" },
    { text: "Apoteker", value: "apoteker" },
    { text: "Asisten Apoteker", value: "asisten_apoteker" },
    { text: "Radiografer", value: "radiografer" },
    { text: "Laboran", value: "laboran" },
    { text: "PPA Lain", value: "ppa_lain" },
    { text: "Tenaga Penunjang", value: "tenaga_penunjang" },
    { text: "Cleaning Service", value: "cleaning_service" },
    { text: "Mahasiswa", value: "mahasiswa" },
    { text: "Lainnya", value: "lainnya" }
  ];

  bufferHeaders = [
    { text: "Petugas", value: "nama_petugas" },
    { text: "Profesi", value: "profesi_jabatan" },
    { text: "Tindakan", value: "tindakan" },
    { text: "APD", value: "apd_summary" },
    { text: "", value: "actions", sortable: false, width: 50 }
  ];

  get canCommit() {
    return (
      this.entry.nama_petugas &&
      this.entry.tindakan_nama &&
      this.entry.details.length > 0
    );
  }

  async mounted() {
    await Promise.all([this.loadMaster(), this.loadSession()]);
  }

  async loadMaster() {
    const jenisRes = await ApdSurveilansService.getJenis();
    this.jenisList = jenisRes.data.data;
    this.resetDetails();
  }

  async loadSession() {
    const res = await ApdSurveilansService.find(this.sessionId);
    const s = res.data.data;
    this.sessionNomor = s.nomor_formulir;
    this.savedCount = (s.observasi_petugas || []).length || s.total_observasi_petugas || 0;
  }

  resetDetails() {
    this.entry.details = this.jenisList.map(j => ({
      apd_jenis_id: j.id,
      hasil: "na" as const
    }));
  }

  getDetail(apdId: number): DetailEntry {
    return (
      this.entry.details.find((d: DetailEntry) => d.apd_jenis_id === apdId) || {
        apd_jenis_id: apdId,
        hasil: "na"
      }
    );
  }

  cycleHasil(apdId: number) {
    const idx = this.entry.details.findIndex(
      (d: DetailEntry) => d.apd_jenis_id === apdId
    );
    if (idx < 0) {
      this.entry.details.push({ apd_jenis_id: apdId, hasil: "patuh" });
      return;
    }
    const order = ["na", "patuh", "tidak_patuh"];
    const next = order[(order.indexOf(this.entry.details[idx].hasil) + 1) % 3];
    this.entry.details.splice(idx, 1, {
      ...this.entry.details[idx],
      hasil: next as any
    });
  }

  hasilColor(h: string) {
    return { patuh: "success", tidak_patuh: "error", na: "grey" }[h] || "grey";
  }

  hasilIcon(h: string) {
    return (
      {
        patuh: "mdi-check-bold",
        tidak_patuh: "mdi-close-thick",
        na: "mdi-minus"
      } as any
    )[h] || "mdi-minus";
  }

  commitEntry() {
    this.buffer.push({
      waktu_observasi: localISO(),
      nama_petugas: this.entry.nama_petugas,
      profesi_jabatan: this.entry.profesi_jabatan,
      tindakan_nama: this.entry.tindakan_nama,
      catatan: this.entry.catatan,
      details: JSON.parse(JSON.stringify(this.entry.details))
    });
    this.entry.nama_petugas = "";
    this.entry.tindakan_nama = "";
    this.entry.catatan = "";
    this.resetDetails();
  }

  removeFromBuffer(idx: number) {
    this.buffer.splice(idx, 1);
  }

  async submitBuffer() {
    if (this.buffer.length === 0) return;
    this.saving = true;
    try {
      await ApdSurveilansService.bulkObservasi(this.sessionId, this.buffer);
      this.savedCount += this.buffer.length;
      this.buffer = [];
    } finally {
      this.saving = false;
    }
  }

  openSubmitDialog() {
    this.submitForm = { password: "", override_min_observasi_reason: "" };
    this.submitDialog = true;
  }

  async confirmSubmit() {
    this.submitting = true;
    try {
      await ApdSurveilansService.submitAuditor(this.sessionId, this.submitForm);
      this.submitDialog = false;
      this.$emit("submitted");
    } finally {
      this.submitting = false;
    }
  }

  countHasil(item: any, hasil: string): number {
    return (item.details || []).filter((d: DetailEntry) => d.hasil === hasil).length;
  }
}
